/**
 * Renderer process constants
 */

import { PageTitleMap } from '../types/config';

// Billing lives under Settings; /dashboard/billing redirects here.
export const BILLING_PAGE_PATH = '/settings/billing';

export const pageTitles: PageTitleMap = {
  '/dashboard': { title: 'Dashboard', subtitle: 'Your business dashboard' },
  '/dashboard/getting-started': {
    title: 'Getting Started',
    subtitle: 'Follow the launch checklist for your first live service',
  },
  '/dashboard/departments': {
    title: 'Departments',
    subtitle: 'Manage your outlet departments',
  },
  '/dashboard/menu': { title: 'Menu', subtitle: 'Manage your menu items' },
  '/dashboard/outlets': {
    title: 'Outlets',
    subtitle: 'Manage your business outlets',
  },
  '/dashboard/clients': {
    title: 'Clients',
    subtitle: 'View company clients and their contact details',
  },
  '/dashboard/reports/sales': {
    title: 'Sales Reports',
    subtitle: 'View your sales analytics',
  },
  '/dashboard/reports/orders': {
    title: 'Orders Report',
    subtitle: 'Review orders across the selected outlet scope',
  },
  '/dashboard/reports/settlements': {
    title: 'Settlements Report',
    subtitle: 'Review settlement activity and payment channels',
  },
  '/dashboard/reports/daily-sales': {
    title: 'Daily Sales Report',
    subtitle: 'Track daily sales summaries across outlets',
  },
  '/dashboard/reports/payment-methods': {
    title: 'Sales Summary Report',
    subtitle: 'Review daily settlement totals by payment method',
  },
  '/dashboard/reports/departments': {
    title: 'Department Sales Report',
    subtitle: 'View department-level sales contribution',
  },
  '/dashboard/reports/items': {
    title: 'Items Report',
    subtitle: 'Inspect item-level sales activity',
  },
  '/dashboard/reports/discounts': {
    title: 'Discounts Report',
    subtitle: 'Audit discounts, reasons, and affected bills',
  },
  '/dashboard/reports/creditors': {
    title: 'Creditors & NC Report',
    subtitle: 'Review credit and non-chargeable settlements',
  },
  '/dashboard/reports/kot-tracking': {
    title: 'KOT Tracking',
    subtitle: 'Reconcile confirmed KOTs against physical paper tickets',
  },
  '/dashboard/reports/credit-bills': {
    title: 'Credit Bills',
    subtitle: 'Find, filter and settle outstanding credit bills',
  },
  '/dashboard/reports/inventory': {
    title: 'Inventory Reports',
    subtitle: 'Track your inventory',
  },
  '/dashboard/settings': {
    title: 'Settings',
    subtitle: 'System settings and preferences',
  },
  '/settings/users': { title: 'Users', subtitle: 'Manage system users' },
  '/settings/roles': {
    title: 'Roles',
    subtitle: 'Manage user roles and permissions',
  },
  '/settings/security': {
    title: 'Security',
    subtitle: 'Security settings and access control',
  },
  '/settings/security/access-controls': {
    title: 'Security',
    subtitle: 'Review the global access control catalog',
  },
  '/settings/security/policies': {
    title: 'Security',
    subtitle: 'Create and manage company access policies',
  },
  '/settings/security/assignments': {
    title: 'Security',
    subtitle: 'Assign policies to outlet roles',
  },
  '/settings/security/registered-devices': {
    title: 'Security',
    subtitle: 'View and manage registered devices',
  },
  '/settings/email-configurations': {
    title: 'Email Configurations',
    subtitle: 'Manage email notification recipients',
  },
  '/settings/ebm/configuration': {
    title: 'EBM Configuration',
    subtitle: 'Configure and activate the RRA fiscal device',
  },
  '/settings/ebm/missing-fiscal-setup': {
    title: 'Missing Fiscal Setup',
    subtitle:
      'Fix menu items missing an EBM tax category, item code, or classification code',
  },
  '/settings/ebm/configured-fiscal-setup': {
    title: 'Configured Fiscal Setup',
    subtitle: 'View and update menu items with a complete EBM fiscal setup',
  },
  '/dashboard/sections-tables': {
    title: 'Sections & Tables',
    subtitle: 'Manage your outlet sections and tables',
  },
  '/dashboard/tables': {
    title: 'Tables',
    subtitle: 'Manage your outlet tables',
  },
  '/sales': {
    title: 'Sales',
    subtitle: 'Point of Sale',
  },
};
